export default "__VITE_ASSET__CVVTybM4__"